<template>
  <div class="feature-highlight py-3">
    <div
      class="row align-items-center g-4"
      :class="{'flex-md-row-reverse': block.value.align === 'right'}"
    >
      <div v-if="block.value.src" class="col-12 col-md-6">
        <img
          :src="block.value.src"
          :alt="block.value.image_alt"
          class="img-fluid rounded shadow-sm"
        />
      </div>
      <div class="feature-text" :class="block.value.src ? 'col-12 col-md-6' : 'col-12'">
        <div v-if="statusBadge || block.value.target" class="d-flex align-items-center gap-2 mb-2">
          <span v-if="statusBadge" class="badge" :class="statusBadge.class">
            {{ statusBadge.label }}
          </span>
          <span v-if="block.value.target" class="text-muted small">{{ block.value.target }}</span>
        </div>
        <h3 class="mt-0">{{ block.value.title }}</h3>
        <div
          class="feature-description"
          @click="onInternalLinkClick"
          v-html="block.value.description"
        ></div>
        <component
          :is="block.value.external_url ? 'a' : 'router-link'"
          v-if="showButton"
          :to="block.value.internal_page_url"
          :href="block.value.external_url || undefined"
          :target="block.value.external_url ? '_blank' : undefined"
          :rel="block.value.external_url ? 'noopener noreferrer' : undefined"
          class="btn btn-outline-primary btn-sm mt-2 d-inline-flex align-items-center gap-1"
        >
          <span>{{ block.value.link_label }}</span>
          <Icon icon="material-symbols:arrow-right-alt" />
        </component>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
import {useLocalisation} from '@/composables/useLocalisation';
import {useInternalLinks} from '@/composables/useInternalLinks';
import {getStatusBadge, hasLink} from './featureCard';

const {block} = defineProps<{block: SphereBlock<'feature_highlight_block'>}>();
const {translate} = useLocalisation();
const {onInternalLinkClick} = useInternalLinks();

const statusBadge = computed(() => getStatusBadge(block.value.status, translate));
const showButton = computed(() => hasLink(block.value));
</script>
